import { Injectable } from '@angular/core';
import { AuthApiService } from '@api/auth_api.service';

import { from } from 'rxjs';
import { sharedResolution } from '@public/src/shared_resolution';

@Injectable()
export class AuthServiceV2 {
	readonly baseUri = '/api/Client/v2';
	private readonly authApiService: AuthApiService = sharedResolution.resolve(AuthApiService);

	getAuthMethods(countryCode: string, callTicket: string, unitId: number) {
		const authApiService = sharedResolution.resolve(AuthApiService);

		return from(authApiService.getAuthMethods(unitId, countryCode, callTicket).then(({ data }) => data));
	}

	/*
	 * SMS
	 */
	public sendSMSCode(unitId: number, number: string, countryCode?: string) {
		return from(this.authApiService.sendSMSCode(unitId, number, countryCode));
	}

	public sendSMSCodeWithCallticket(unitId: number, countryCode: string, callTicket: string) {
		return from(this.authApiService.sendSMSCodeWithCallticket(unitId, countryCode, callTicket));
	}

	public resendSmsCode(unitId: number, authAttemptId: Guid) {
		return from(this.authApiService.resendSmsCode(unitId, authAttemptId));
	}

	public getPreRegisteredNumber(callTicket: string, unitId: number) {
		return from(this.authApiService.getPreRegisteredNumber(unitId, callTicket));
	}

	public confirmSmsCode(unitId: number, attemptId: Guid, code: string, sessionLifetime?: number) {
		return from(this.authApiService.confirmSmsCode(unitId, attemptId, code, sessionLifetime));
	}

	/**
	 * NoAuth
	 */
	public startNoAuthAuth(unitId: number, callTicket: string, countryCode?: string) {
		return from(this.authApiService.beginNoAuth(unitId, callTicket, countryCode));
	}

	public confirmNoAuthIdentity(unitId: number, attemptId: Guid, commonName: string) {
		return from(this.authApiService.confirmNoAuthIdentity(unitId, attemptId, commonName));
	}
}
